import { render, staticRenderFns } from "./processAccident.vue?vue&type=template&id=8bb36ee6"
import script from "./processAccident.vue?vue&type=script&lang=js"
export * from "./processAccident.vue?vue&type=script&lang=js"
import style0 from "./processAccident.vue?vue&type=style&index=0&id=8bb36ee6&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bb36ee6')) {
      api.createRecord('8bb36ee6', component.options)
    } else {
      api.reload('8bb36ee6', component.options)
    }
    module.hot.accept("./processAccident.vue?vue&type=template&id=8bb36ee6", function () {
      api.rerender('8bb36ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccident.vue"
export default component.exports